import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { CookieSetting } from "cookiesetting-component";
import AngelAIWidget from './AngelAIWidget';
import './index.css';
import HomePage from './homepage';
import reportWebVitals from './reportWebVitals';
import DynamicPage from './DynamicPage';
import LoanOfficerPage from './LoanOfficerPage';
import { MLOProvider, useMLO } from './MLOContext';

const baseName = process.env.REACT_APP_BASENAME;

const WidgetWrapper = () => {
  const location = useLocation();
  const { mloData, isInfluencer } = useMLO();
  const pathSegments = location.pathname.replace(baseName || '', '').split('/').filter(Boolean);
  const isPersonPage = pathSegments.length === 2;

  const widgetReady = isPersonPage ? !!mloData : true;
  const widgetCustomLink = isPersonPage ? mloData?.angelaiUrl : undefined;
  const widgetUserType = isPersonPage
    ? (isInfluencer ? 'influencer' : 'loanofficer')
    : 'default';

  return <AngelAIWidget customLink={widgetCustomLink} userType={widgetUserType} isReady={widgetReady} />;
};

const AppWrapper = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:editionName" element={<DynamicPage />} />
        <Route path="/:loanOfficerName/:editionName" element={<LoanOfficerPage />} />
      </Routes>
      <CookieSetting
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      <WidgetWrapper />
    </>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={baseName}>
      <MLOProvider>
        <AppWrapper />
      </MLOProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
